<template>
  <b-modal
    ref="genderModal"
    size="xs"
    centered
    modal-class="gender-modal"
    @hidden="hide"
  >
    <div slot="modal-title">
      {{ actionTitle }} <span style="text-transform: lowercase">{{ $t('configuration.sections.gender') }}</span>
    </div>
    <b-row class="pt-2 pb-3 px-3">
      <b-col cols="12">
        <div class="form-label">
          <label>{{ $t('configuration.grid.code') }}</label>
        </div>
        <vt-input
          ref="code"
          v-model="internalGender.code"
          class="form-control-sm"
        />
      </b-col>
      <b-col
        cols="12"
        class="mt-3"
      >
        <div class="form-label">
          <label>{{ $t('configuration.sections.gender') }}</label>
        </div>
        <ConfigurationNameTranslations :name-translations="internalGender.nameTranslations" />
      </b-col>
      <b-col
        cols="12"
        class="mt-3 d-flex justify-content-end"
      >
        <div class="switch-btn mt-1 p-0 d-flex align-items-center">
          <span
            v-if="internalGender.active"
            class="mr-2"
          >{{ $t('configuration.actions.active') }}</span>
          <span
            v-else
            class="mr-2"
          >{{ $t('configuration.actions.inactive') }}</span>
          <input
            id="toggle"
            v-model="internalGender.active"
            type="checkbox"
            class="offscreen"
            aria-hidden="true"
          >
          <label
            for="toggle"
            class="switch mb-0"
          />
        </div>
      </b-col>
    </b-row>
    <div
      slot="modal-footer"
      class="footer-banner px-2"
      style="width:100%;"
    >
      <div class="row">
        <div class="col-6 text-left">
          <b-button
            size="sm"
            variant="outline-secondary"
            data-dismiss="modal"
            @click="hide"
          >
            {{ $t('global.cancel') }}
          </b-button>
        </div>
        <div class="col-6 text-right">
          <b-button
            :disabled="!internalGender.code || !internalGenderHasDefaultLanguage"
            size="sm"
            class="btn--primary"
            @click="update()"
          >
            <i
              class="fal fa-check mr-2"
              aria-hidden="true"
            />
            {{ actionTitle }}
          </b-button>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import ConfigurationNameTranslations from '@/modules/configurationModule/detail/ConfigurationNameTranslations'
import languageService from '@/api/resources/common/languageService'
import { cloneDeep, isEmpty, uniqBy } from 'lodash'

export default {
    name: 'GenderModal',
    components: { ConfigurationNameTranslations },
    props: {
        actionTitle: String
    },
    data() {
        return {
            internalGender: {}
        }
    },
    computed: {
        internalGenderHasDefaultLanguage() {
            let hasDefaultLanguage = false
            const defaultLanguage = this.internalGender.nameTranslations.find(name => name.language.defaultLanguage)
            if (defaultLanguage) {
                hasDefaultLanguage = !!defaultLanguage.value.length
            }
            return hasDefaultLanguage
        }
    },
    methods: {
        async show(selectedGender) {
            let allNameTranslations = []
            this.updateLoading(true)
            const [err, response] = await this.toCall(languageService.findAllActiveAndUiEnabled())
            this.updateLoading(false)
            if (err) {
                this.showErrorModalGlobalFromErrorResponse(err)
                return
            }
            const activeUILanguages = response
            if (selectedGender && !isEmpty(selectedGender)) {
                this.internalGender = cloneDeep(selectedGender)
            } else {
                this.clearData()
            }
            const defaultNameTranslations = activeUILanguages.map(lang => {
                return {
                    language: lang,
                    notes: '',
                    value: ''
                }
            })
            allNameTranslations = uniqBy(this.internalGender.nameTranslations.concat(defaultNameTranslations), 'language.id')
            this.internalGender.nameTranslations = allNameTranslations
            this.$refs.genderModal.show()
            this.$nextTick(() => {
                this.$refs.code.focus()
            })
        },
        hide() {
            this.$refs.genderModal.hide()
        },
        update() {
            if (this.internalGender.id) this.$emit('update', this.internalGender)
            else this.$emit('create', this.internalGender)
        },
        clearData() {
            this.internalGender = {
                active: true,
                code: '',
                name: '',
                nameTranslations: []
            }
        }
    }
}
</script>

<style lang="scss">
    .gender-modal .translations-area {
        max-height: 100px;
        overflow-y: auto;
        padding-bottom: 3px;
    }
</style>
